(() => {
  if (!document.body.classList.contains('nh-retail')) return;
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const tabs = [...root.querySelectorAll('[data-product-tab]')];
    const nav = root.querySelector('nav'), holder = root.querySelector('[data-tabs-panels]');
    const status = root.querySelector('[role="status"]'), retry = root.querySelector('.nh-tabs__retry');
    const all = root.querySelector('.nh-tabs__all'), heading = root.querySelector('[data-tabs-heading]');
    const arrows = [...root.querySelectorAll('[data-direction]')];
    const cache = new Map(), pending = new Map(), controllers = new Set();
    let active = -1, sequence = 0, destroyed = false, warming = false;
    const connection = navigator.connection;
    const mayPrefetch = !connection?.saveData && !/(^|-)2g$/.test(connection?.effectiveType || '');
    nav.setAttribute('role','tablist');
    root.querySelector('.nh-tabs__arrows').hidden = false;
    const panels = tabs.map((tab,i) => {
      const panel = document.createElement('div');
      tab.id = root.id + '-tab-' + i; tab.setAttribute('role','tab');
      panel.id = root.id + '-panel-' + i; panel.hidden = true;
      panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',tab.id); panel.tabIndex = 0;
      tab.setAttribute('aria-controls',panel.id); holder.append(panel); return panel;
    });
    function updateArrows() {
      const rail = panels[active]?.querySelector('.nh-tabs__rail');
      arrows[0].disabled = !rail || rail.scrollLeft <= 2;
      arrows[1].disabled = !rail || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }
    function prepareImages(i) {
      const count = matchMedia('(max-width: 767px)').matches ? 2 : 4;
      panels[i].querySelectorAll('.nh-card__image img').forEach((img,n)=>{
        if(n < count) {
          img.fetchPriority = i === active ? 'auto' : 'low';
          img.loading = 'eager';
        }
      });
    }
    function load(i) {
      if (cache.has(i)) return Promise.resolve();
      if (pending.has(i)) return pending.get(i);
      const task = fetchPanel(i).finally(()=>pending.delete(i));
      pending.set(i,task);
      return task;
    }
    async function fetchPanel(i) {
      const panel = panels[i], tab = tabs[i];
      const controller = new AbortController(); controllers.add(controller);
      const timeout = setTimeout(()=>controller.abort(),15000);
      try {
        const url = new URL(tab.href);
        url.searchParams.set('section_id','nh-tab-products');
        if(window.Shopify?.theme?.role !== 'main' && window.Shopify?.theme?.id) url.searchParams.set('preview_theme_id',window.Shopify.theme.id);
        const response = await fetch(url,{signal:controller.signal,credentials:'same-origin'});
        if(!response.ok) throw new Error('http');
        const doc = new DOMParser().parseFromString(await response.text(),'text/html');
        const result = doc.querySelector('[data-nh-tab-result]');
        if(!result || (i===0 && result.dataset.sort!=='best-selling')) throw new Error('invalid');
        if(destroyed || !root.isConnected) return;
        // Only insert the server-rendered product fragment, never executable scripts.
        result.querySelectorAll('script').forEach(s=>s.remove());
        // Each cached panel owns unique product form IDs.
        result.querySelectorAll('[id]').forEach(el=>{el.id=root.id+'-'+i+'-'+el.id});
        panel.replaceChildren(...result.childNodes);
        cache.set(i,true);prepareImages(i);
        panel.querySelector('.nh-tabs__rail')?.addEventListener('scroll',updateArrows,{passive:true});
      } finally {
        clearTimeout(timeout);
        controllers.delete(controller);
      }
    }
    async function select(i) {
      active = i; const ticket = ++sequence;
      tabs.forEach((t,n)=>{t.setAttribute('aria-selected',String(n===i));t.tabIndex=n===i?0:-1;panels[n].hidden=n!==i;panels[n].removeAttribute('aria-busy')});
      const tab=tabs[i], panel=panels[i];
      heading.textContent=tab.textContent;
      all.href=tab.href;all.textContent='Se alle '+tab.textContent.toLowerCase();
      retry.hidden=true;status.textContent='';
      if(cache.has(i)){prepareImages(i);updateArrows();return}
      panel.setAttribute('aria-busy','true');status.textContent='Henter '+tab.textContent.toLowerCase()+'…';updateArrows();
      try {
        await load(i);
        if(ticket!==sequence || destroyed) return;
        prepareImages(i);status.textContent='';
      } catch {
        if(ticket===sequence && !destroyed){status.textContent='Produkterne kunne ikke hentes. Prøv igen, eller vælg en anden fane.';retry.hidden=false}
      } finally {
        if(ticket===sequence && !destroyed){panel.removeAttribute('aria-busy');updateArrows()}
      }
    }
    // Warm only the first visible row, sequentially, once shoppers approach this section.
    async function warm() {
      if(warming || !mayPrefetch || destroyed) return;
      warming=true;
      for(let i=0;i<tabs.length && !destroyed;i++) {
        try {await load(i)} catch { /* An explicit click can retry a failed prefetch. */ }
      }
    }
    const near = new IntersectionObserver(entries=>{
      if(entries.some(entry=>entry.isIntersecting)) {near.disconnect();warm()}
    },{rootMargin:'150px'});
    near.observe(root);
    tabs.forEach((tab,i)=>{
      const intent=()=>{if(mayPrefetch && !destroyed)load(i).catch(()=>{})};
      tab.addEventListener('pointerenter',intent);
      tab.addEventListener('focus',intent);
      tab.addEventListener('touchstart',intent,{passive:true});
      tab.addEventListener('click',e=>{if(e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();select(i)});
      tab.addEventListener('keydown',e=>{
        let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;
        if(next!==undefined){e.preventDefault();tabs[next].focus();select(next)}
        if(e.key===' '){e.preventDefault();select(i)}
      });
    });
    arrows.forEach(button=>button.addEventListener('click',()=>{
      const rail=panels[active].querySelector('.nh-tabs__rail');if(!rail)return;
      rail.scrollBy({left:Number(button.dataset.direction)*rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
    }));
    retry.addEventListener('click',()=>select(active));
    const observer=new ResizeObserver(updateArrows);observer.observe(root);
    root.addEventListener('nh:destroy',()=>{destroyed=true;controllers.forEach(controller=>controller.abort());observer.disconnect();near.disconnect()},{once:true});
    select(0);
  }
  function scan(scope=document){scope.querySelectorAll('[data-nh-product-tabs]').forEach(init)}
  scan();document.addEventListener('shopify:section:load',e=>scan(e.target));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-nh-product-tabs]').forEach(r=>r.dispatchEvent(new Event('nh:destroy'))));
})();
